import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { syncQueryToStore } from '../utils/syncQueryToStore';
export const useUrlQueryStoreSync = () => {
  const _useLocation = useLocation(),
    search = _useLocation.search;
  const queryFromUrl = useMemo(() => {
    var _URLSearchParams$get;
    return ((_URLSearchParams$get = new URLSearchParams(search).get('query')) == null ? void 0 : _URLSearchParams$get.trim()) ?? '';
  }, [search]);
  useEffect(() => {
    if (!queryFromUrl) {
      return;
    }
    syncQueryToStore(queryFromUrl);
  }, [queryFromUrl]);
  return queryFromUrl;
};
//# sourceMappingURL=useUrlQueryStoreSync.js.map